import makeStyles from '@mui/styles/makeStyles/makeStyles'
import { Theme } from '@mui/material'

const useStyles = makeStyles<Theme>(theme => ({
  root: {
    margin: '0px 10px',
    cursor: 'pointer'
  },
  modalTitle: {
    marginBottom: '0px',
    fontWeight: 700,
    fontSize: theme.size.lg,
    lineHeight: '20px',
    color: '#1F1F1F'
  },

  modalClose: {
    top: '16px',
    right: '12px'
  },
  dataRoot: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #C6C6C6',
    borderRadius: '4px',
    boxSizing: 'border-box',
    padding: 16,
    background: '#F5F6F8',
    marginTop: 16,
    transition: 'all 250ms',
    [theme.breakpoints.down('md')]: {
      flex: 1
    },
    '& div:first-child': {
      marginTop: 0
    }
  },
  subheaderLaber: {
    color: 'rgba(0, 0, 0, 0.6)'
  },
  notificationRow: {
    marginTop: 6,
    gap: 6
  },
  timeSelectionSectionRoot: { marginTop: 6 },
  sectionRoot: {
    display: 'flex',
    flexFlow: 'column',
    position: 'relative',
    boxSizing: 'border-box',
    marginTop: '16px',
    borderBottom: '1px solid #C6C6C6'
  },
  descriptionRoot: {
    display: 'flex',
    boxSizing: 'border-box',
    marginTop: '16px',
    borderBottom: '1px solid #C6C6C6'
  },
  borderlessSectionRoot: {
    display: 'flex',
    flexFlow: 'column',
    position: 'relative',
    boxSizing: 'border-box',
    marginTop: '16px'
  },

  item: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '4px',
    marginRight: '4px',
    borderRadius: '100rem',
    border: `1px solid ${theme.palette.primary.main}`,
    background: theme.palette.secondary.main,
    color: theme.palette.primary.main,
    padding: '6px 10px',
    fontSize: theme.size.base,
    lineHeight: '15px',
    userSelect: 'none',
    fontWeight: 700,
    cursor: 'pointer',

    '&:last-child': {
      marginRight: '0'
    }
  },
  dateSelector: {
    cursor: 'pointer'
  },
  btnSection: {
    justifyContent: 'space-between',
    display: 'flex',
    marginTop: 16
  },

  optionList: {
    padding: 12,
    border: '1px solid #F0F0F0',
    boxShadow: '0px 20px 30px 2px rgba(0, 0, 0, 0.16)',
    borderRadius: '5px',
    width: 180,
    backgroundColor: 'white'
  },
  option: {
    borderRadius: '4px',
    padding: '10px',
    fontSize: '14px',
    lineHeight: '17px',
    color: '#3C425B',
    cursor: 'pointer',
    transition: 'all 200ms',

    '&:hover': {
      background: '#F5F6F8'
    }
  },

  addNotifBtn: {
    marginBottom: 4
  },

  reminderRow: {
    marginTop: '6px !important',
    margin: '6px 0px',
    display: 'flex',
    gap: 6,
    alignItems: 'center'
  },

  includeRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    marginBottom: 6
  },

  accordionRoot: {
    padding: '0 !important',
    backgroundColor: '#F5F6F8 !important'
  },

  accordionContainer: {
    padding: '0.5rem 0px !important',
    backgroundColor: '#F5F6F8 !important'
  },

  accordionTitle: {
    padding: '0 !important',
    color: 'rgba(0, 0, 0, 0.6)',
    marginBottom: 6
  },

  actionButtons: {
    alignItems: 'center',
    display: 'flex',
    gap: 6
  },

  ctaButton: {
    [theme.breakpoints.down('sm')]: {
      width: 'auto !important'
    }
  }
}))

export default useStyles
